import axios from "axios";

import API_URL from "../redux2";

const FLIGHT_API_PATH = /^(flight|ndc|amadeus|airarabia|air-arabia)(\/|$)/i;

const getStoredToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user?.token) return null;

  const storedToken = user?.token;

  try {
    const parsedToken = JSON.parse(storedToken);

    if (typeof parsedToken === "string") return parsedToken;
    if (parsedToken?.token) return parsedToken.token;
    if (parsedToken?.access_token) return parsedToken.access_token;
  } catch (_) {
    return storedToken;
  }

  return storedToken;
};

const isFlightApiRequest = (config) => {
  try {
    const apiUrl = new URL(API_URL);
    const requestUrl = new URL(config.url || "", config.baseURL || API_URL);

    if (requestUrl.origin !== apiUrl.origin) return false;

    const apiPath = apiUrl.pathname.replace(/\/+$/, "");
    if (
      requestUrl.pathname !== apiPath &&
      !requestUrl.pathname.startsWith(`${apiPath}/`)
    ) {
      return false;
    }

    const requestPath = requestUrl.pathname
      .slice(apiPath.length)
      .replace(/^\/+/, "");

    return FLIGHT_API_PATH.test(requestPath);
  } catch (_) {
    return false;
  }
};

export const addFlightAuthorization = (config) => {
  if (!isFlightApiRequest(config)) return config;

  const token = getStoredToken();
  if (!token) return config;

  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${token}`;

  return config;
};

axios.interceptors.request.use(addFlightAuthorization);
